import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Phone, Mail, MapPin } from "lucide-react";
import { api, LOGO_URL } from "../../lib/api";

export const Footer = () => {
  const [s, setS] = useState({});
  useEffect(() => { api.get("/content").then((r) => setS(r.data.settings?.settings || {})).catch(() => {}); }, []);

  const social = [
    { icon: Facebook, href: s.facebook, label: "Facebook" },
    { icon: Instagram, href: s.instagram, label: "Instagram" },
    { icon: Linkedin, href: s.linkedin, label: "LinkedIn" },
  ].filter((x) => x.href);

  return (
    <footer className="relative bg-[#060A17] border-t border-[#D4AF37]/15 pt-16 pb-28 xl:pb-10" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid grid-cols-1 md:grid-cols-4 gap-10">
        <div className="md:col-span-2">
          <img src={LOGO_URL} alt="Next Mile Compliance LLC" className="h-14 w-auto object-contain mb-5" />
          <p className="text-gray-400 text-sm max-w-md leading-relaxed">
            Helping trucking companies start right, stay compliant, and keep moving. From Authority to Audit — we're with you every mile.
          </p>
          <div className="flex gap-3 mt-5">
            {social.map((x) => (
              <a key={x.label} href={x.href} target="_blank" rel="noreferrer"
                 className="w-10 h-10 rounded-full border border-white/10 flex items-center justify-center text-gray-300 hover:text-[#0B132B] hover:nm-gold-bg transition-all">
                <x.icon size={17} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-head font-bold text-white mb-4 text-sm tracking-wider">SERVICES</h4>
          <ul className="space-y-2.5 text-sm text-gray-400">
            <li><Link to="/dispatch" className="hover:text-[#D4AF37]">Dispatch Services</Link></li>
            <li><Link to="/hr-back-office" className="hover:text-[#D4AF37]">HR & Back-Office</Link></li>
            <li><Link to="/start-a-trucking-company" className="hover:text-[#D4AF37]">Start a Company</Link></li>
            <li><Link to="/dispatch-class" className="hover:text-[#D4AF37]">Dispatch Training</Link></li>
            <li><Link to="/safety-audit" className="hover:text-[#D4AF37]">Safety Audit Prep</Link></li>
            <li><Link to="/elite-mentorship" className="hover:text-[#D4AF37]">Elite Mentorship</Link></li>
          </ul>
        </div>

        <div>
          <h4 className="font-head font-bold text-white mb-4 text-sm tracking-wider">CONTACT</h4>
          <ul className="space-y-3 text-sm text-gray-400">
            {s.phone && <li><a href={`tel:${s.phone}`} className="flex items-center gap-2 hover:text-[#D4AF37]"><Phone size={15} />{s.phone}</a></li>}
            {s.email && <li><a href={`mailto:${s.email}`} className="flex items-center gap-2 hover:text-[#D4AF37]"><Mail size={15} />{s.email}</a></li>}
            {s.address && <li className="flex items-center gap-2"><MapPin size={15} />{s.address}</li>}
            <li><Link to="/contact" className="text-[#D4AF37] font-semibold">Get in touch →</Link></li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 pt-6 border-t border-white/5">
        <p className="text-[11px] text-gray-500 leading-relaxed max-w-4xl">
          Next Mile Compliance LLC is an independent business and is not FMCSA, DOT, or any other government agency. Government filing fees,
          insurance premiums, third-party vendor charges, and other outside expenses may be separate unless specifically included in the client's
          written service agreement. Final authority approval is determined by the applicable government agencies. Freight availability, rates, and
          revenue vary and are not guaranteed.
        </p>
        <div className="flex flex-wrap items-center justify-between gap-3 mt-5">
          <p className="text-xs text-gray-500">© {new Date().getFullYear()} Next Mile Compliance LLC. All rights reserved.</p>
          <Link to="/admin" className="text-xs text-gray-600 hover:text-[#D4AF37]" data-testid="footer-admin-link">Admin Login</Link>
        </div>
      </div>
    </footer>
  );
};
